import { reviewConstants } from "../actions/constants/reviewConstants";

export const getSchoolByRatingsReducer = (state = {}, action: any) => {
  switch (action.type) {
    case reviewConstants.getSchoolByRatingsRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case reviewConstants.getSchoolByRatingsSuccess:
      return { isLoading: false, isSuccess: true, isError: false, schooldata: action.payload };
    case reviewConstants.getSchoolByRatingsFailure:
        return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
        return state;
  }
}

export const listReviewsReducer = (state = {}, action: any) => {
  switch (action.type) {
    case reviewConstants.listReviewsRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case reviewConstants.listReviewsSuccess:
      return { isLoading: false, isSuccess: true, isError: false, data: action.payload };
    case reviewConstants.listReviewsFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const getInstructorRatingsReducer = (state = {}, action: any) => {
  switch (action.type) {
    case reviewConstants.getInstructorRatingsRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case reviewConstants.getInstructorRatingsSuccess:
      return { isLoading: false, isSuccess: true, isError: false, data: action.payload };
    case reviewConstants.getInstructorRatingsFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const getSchoolRatingsReducer = (state: any = {}, action: any) => {
  switch (action.type) {
    case reviewConstants.getSchoolRatingsRequest:
      return { ...state, isLoading: true, isSuccess: false, isError: false };
    case reviewConstants.getSchoolRatingsSuccess:
      return { isLoading: false, isSuccess: true, isError: false, data: action.payload };
    case reviewConstants.getSchoolRatingsFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const deleteReviewReducer = (state = {}, action: any) => {
  switch (action.type) {
    case reviewConstants.deleteReviewRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case reviewConstants.deleteReviewSuccess:
      return { isLoading: false, isSuccess: true, isError: false };
    case reviewConstants.deleteReviewFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};

export const viewReviewReducer = (state = {}, action: any) => {
  switch (action.type) {
    case reviewConstants.viewReviewRequest:
      return { isLoading: true, isSuccess: false, isError: false };
    case reviewConstants.viewReviewSuccess:
      return { isLoading: false, isSuccess: true, isError: false, data: action.payload };
    case reviewConstants.viewReviewFailure:
      return { isLoading: false, isSuccess: false, isError: true, error: action.payload };
    default:
      return state;
  }
};